import Logger from '@/lib/logger';
import { NEXT_PUBLIC_SNAPCHAT_LOGGING_ENABLED } from '@/lib/env';

const logger = new Logger('Snapchat', 'DEBUG');

if (NEXT_PUBLIC_SNAPCHAT_LOGGING_ENABLED) {
  logger.enable();
}

export default logger;
